// Live wallet balance, refetched on play/purchase.
import { create } from 'zustand';

interface WalletState {
  balance: number | null;
  setBalance: (balance: number) => void;
  reset: () => void;
}

export const useWalletStore = create<WalletState>((set) => ({
  balance: null,
  setBalance: (balance) => set({ balance }),
  reset: () => set({ balance: null }),
}));
